<script setup lang="ts">
import type { TabsTriggerProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import type { RouteLocationRaw } from 'vue-router'
import { reactiveOmit } from '@vueuse/core'
import { computed, resolveComponent } from 'vue'
import { useRouter } from 'vue-router'
import TabsTrigger from './TabsTrigger.vue'

const props = defineProps<
  Omit<TabsTriggerProps, 'value'> & {
    to: RouteLocationRaw
    value?: string
    class?: HTMLAttributes['class']
  }
>()

const NuxtLink = resolveComponent('NuxtLink')
const router = useRouter()

const resolvedValue = computed(() => {
  if (props.value != null) return props.value
  if (typeof props.to === 'string') return props.to
  return router.resolve(props.to).href
})

const delegated = reactiveOmit(props, 'to', 'value')
</script>

<template>
  <TabsTrigger v-bind="delegated" :value="resolvedValue" as-child>
    <component :is="NuxtLink" :to="to">
      <slot />
    </component>
  </TabsTrigger>
</template>
